<a class="nav-link dropdown-toggle" id="profileDropdown" href="#" data-toggle="dropdown" aria-expanded="false">
    <div class="nav-profile-img">
        <img src="assets/images/users.png" alt="image">
        <span class="availability-status online"></span>
    </div>
    <div class="nav-profile-text">
        <p class="mb-1 text-black"><a>{{admin_data.person_name}}</a></p>
    </div>
</a>
<div class="dropdown-menu navbar-dropdown" aria-labelledby="profileDropdown">
    <a class="nav-link" [routerLink]="[ '/settings']">
        <i class="mdi mdi-settings mr-2 text-primary"></i> ตั้งค่าระบบ
    </a>
    <a class="dropdown-item" href="#" (click)="logout()">
        <i class="mdi mdi-logout mr-2 text-success"></i> ออกจากระบบ </a>
</div>